import { render, staticRenderFns } from "./xlsProducts.vue?vue&type=template&id=c99e9d36&scoped=true&"
import script from "./xlsProducts.vue?vue&type=script&lang=js&"
export * from "./xlsProducts.vue?vue&type=script&lang=js&"
import style0 from "./xlsProducts.vue?vue&type=style&index=0&id=c99e9d36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99e9d36",
  null
  
)

export default component.exports